/**
 * Invariant function for runtime assertions with TypeScript type narrowing
 * @param condition - The condition to assert
 * @param message - Optional error message
 * @throws Error if the condition is falsy
 */
export function invariant(condition: any, message?: string): asserts condition {
    if (!condition) {
        const errorMessage = message || 'Assertion failed'
        throw new Error(errorMessage)
    }
}
